import React from 'react';

interface State {}

const UsersMassiveMailPage = () => {
  return <>진행x</>;
};

export default UsersMassiveMailPage;
